/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';

export const ProfileImage = styled(Image)`
  width: 120px;
  height: 120px;
  object-fit: cover;
  text-align: center;
`;

export const ImgCol = styled(Col)`
  @media (max-width: 480px) {
    text-align: center;
  }
`;
